import React, { FC, useState } from 'react'
import classes from './WorkersModal.module.scss'
import { Edit } from '@mui/icons-material'
import { Modal, useTheme } from '@mui/material'
import { useRecoilState } from 'recoil'
import { userState } from '../../../../states/userState'
import { User, Worker, WorkerWithDiary } from '../../../../types'
import EditWorkersMain from './main/WorkersMain'
import { setUserToLocalStorage } from '../../../../utils/functions/localStorageManager'
import WorkersHeader from './header/WorkersHeader'
import WorkersMain from './main/WorkersMain'

type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>
  workerList: Array<WorkerWithDiary>
  setWorkerList: React.Dispatch<React.SetStateAction<WorkerWithDiary[]>>
  workingDate: { obj: Date; text: string }
  setDefaultFactoryNo: React.Dispatch<React.SetStateAction<number>>
}

const WorkersModal: FC<Props> = (props) => {
  const {
    workerList,
    setWorkerList,
    setIsShow,
    workingDate,
    setDefaultFactoryNo,
  } = props
  const theme = useTheme()
  const [open, setOpen] = useState(true)
  const [user, setUser] = useRecoilState(userState)

  const handleSaveButtonClick = () => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          workersForMultiInput: workerList,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
    setOpen(false)
    setIsShow(false)
  }
  const handleCancelButtonClick = () => {
    setOpen(false)
    setIsShow(false)
  }

  const handleSearchButtonClick = () => {}
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: 'none',
        '&:focus-visible': {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div className={classes.formContainer}>
        <WorkersHeader
          workingDate={workingDate}
          onSave={handleSaveButtonClick}
          onCancel={handleCancelButtonClick}
          setWorkerList={setWorkerList}
          workerList={workerList}
          setDefaultFactoryNo={setDefaultFactoryNo}
        />
        <WorkersMain workerList={workerList} setWorkerList={setWorkerList} />
      </div>
    </Modal>
  )
}

export default WorkersModal
